import { eFilterType, ITableFilter } from '@logicalcommander/types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import deepEqual from 'deep-equal'
import { removeObjectByKeyValuePair } from '../../utils/general'
import { RootState } from '../store'
import { readSessionTableFilters } from './table-filter-session'

interface ITableFiltersState {
  history: ITableFilter[] // The client use this for history filters (no server)
  tableHeader: ITableFilter[] // The client use this for filters
  defaultFilters: ITableFilter[] // Comming from server
  favoriteFilters: ITableFilter[] // Comming from server
}

const initialState: ITableFiltersState = {
  history: [],
  tableHeader: [],
  defaultFilters: [],
  favoriteFilters: [],
}

export const filtersSlice = createSlice({
  name: 'filtersReducer',
  initialState,
  reducers: {
    initDefaultFilters: (state: ITableFiltersState, action: PayloadAction<ITableFilter[]>) => {
      state.defaultFilters = [...action.payload]
      state.tableHeader = [...action.payload]
    },
    initFavoriteFilters: (state: ITableFiltersState, action: PayloadAction<ITableFilter[]>) => {
      state.favoriteFilters = [...action.payload]
    },
    setActiveFavoriteFilters: (state: ITableFiltersState, action: PayloadAction<ITableFilter[]>) => {
      state.tableHeader = [...action.payload]
    },
    addFilter: (state: ITableFiltersState, action: PayloadAction<ITableFilter>) => {
      const existInHistory = state.history.find((i) => deepEqual(i, action.payload))
      const existInTableHeader = state.tableHeader.find((i) => deepEqual(i, action.payload))
      if (!existInHistory) state.history.push(action.payload)
      if (!existInTableHeader) state.tableHeader.push(action.payload)
    },
    deleteFilter: (state: ITableFiltersState, action: PayloadAction<ITableFilter>) => {
      const tableHeader = state.tableHeader.filter((item) => !deepEqual(item, action.payload))
      return {
        ...state,
        tableHeader,
      }
    },
    setSearchFilter: (state: ITableFiltersState, action: PayloadAction<ITableFilter>) => {
      state.tableHeader = [action.payload]
    },
    setSearchFilters: (state: ITableFiltersState, action: PayloadAction<ITableFilter[]>) => {
      state.tableHeader = action.payload
    },
    addSearchFilter: (state: ITableFiltersState, action: PayloadAction<ITableFilter>) => {
      state.tableHeader.push(action.payload)
    },
    clearSearchFilter: (state: ITableFiltersState, action: PayloadAction<any>) => {
      state.tableHeader = removeObjectByKeyValuePair<ITableFilter>(state.tableHeader, 'type', eFilterType.SEARCH)
    },
    restoreSessionTableFilters: (state: ITableFiltersState) => {
      const saved = readSessionTableFilters()
      if (saved) {
        state.tableHeader = saved
      }
    },
    clearAppliedFilters: (state: ITableFiltersState) => {
      state.tableHeader = []
      state.history = []
    },
  },
})

export const {
  addFilter,
  deleteFilter,
  addSearchFilter,
  clearSearchFilter,
  setSearchFilter,
  setSearchFilters,
  initDefaultFilters,
  initFavoriteFilters,
  setActiveFavoriteFilters,
  restoreSessionTableFilters,
  clearAppliedFilters,
} = filtersSlice.actions
export default filtersSlice.reducer
export const selectFilters = (state: RootState): ITableFiltersState => state.filtersReducer
